import cn from 'clsx';
import {extendTailwindMerge} from 'tailwind-merge';

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            padding: [{pt: ['hw-offset']}, {pb: ['safe-or']}],
        },
        conflictingClassGroups: {
            pt: ['pt'],
            pb: ['pb'],
        },
        theme: {
            spacing: (value: string) => {
                return (
                    /^[\d.]+(?:-hw-offset)?$/.test(value) ||
                    /^safe-or-[\d.]+$/.test(value) ||
                    /^safe-hw-inset-\d+$/.test(value) ||
                    value === 'safe-offset-sticky-header'
                );
            },
        },
    },
});

export const twx = (...props: Parameters<typeof cn>) => twMerge(cn(props));
